import { Receipt, Globe2, ScrollText } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

const ICONS = [Receipt, Globe2, ScrollText];

export default function HowItWorks() {
    const { tRaw, t } = useI18n();
    const items = tRaw("how.items") || [];

    return (
        <section id="how" data-testid="how-it-works-section" className="max-w-7xl mx-auto px-4 sm:px-6 py-16 scroll-mt-20">
            <div className="max-w-2xl">
                <div className="text-xs font-semibold tracking-[0.2em] uppercase text-slate-500">{t("how.eyebrow")}</div>
                <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl tracking-tight font-bold text-slate-900">
                    {t("how.title")}
                </h2>
                <p className="mt-3 text-slate-600 leading-relaxed">{t("how.intro")}</p>
            </div>

            <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
                {items.map((it, i) => {
                    const Icon = ICONS[i] || Receipt;
                    return (
                        <div
                            key={i}
                            data-testid={`how-card-${i}`}
                            className="rounded-xl border border-slate-200 bg-white p-6 hover:shadow-sm transition-shadow"
                        >
                            <div className="inline-flex h-10 w-10 items-center justify-center rounded-md bg-emerald-50 text-[#10B981]">
                                <Icon className="h-5 w-5" />
                            </div>
                            <h3 className="font-display mt-4 text-lg font-bold text-slate-900">{it.title}</h3>
                            <p className="mt-2 text-sm text-slate-600 leading-relaxed">{it.body}</p>
                        </div>
                    );
                })}
            </div>
        </section>
    );
}
